import { request, buildQuery } from '../../lib/apiClient';
export function listEstimates(params) {
    const query = buildQuery({
        status: params?.status,
        customerId: params?.customerId,
        convertedToProjectId: params?.convertedToProjectId,
        limit: params?.limit,
        nextToken: params?.nextToken,
    });
    return request(`/estimates${query}`);
}
export function getEstimateByProjectId(projectId) {
    return listEstimates({ convertedToProjectId: projectId }).then((r) => r.items[0] ?? null);
}
export function getEstimate(id) {
    return request(`/estimates/${id}`);
}
export function createEstimate(input) {
    return request('/estimates', {
        method: 'POST',
        body: JSON.stringify(input),
    });
}
export function updateEstimate(id, input) {
    return request(`/estimates/${id}`, {
        method: 'PUT',
        body: JSON.stringify(input),
    });
}
export function deleteEstimate(id) {
    return request(`/estimates/${id}`, {
        method: 'DELETE',
    });
}
export function convertEstimate(id) {
    return request(`/estimates/${id}/convert`, {
        method: 'PATCH',
        body: JSON.stringify({}),
    });
}
export function getUploadUrl(estimateId, filename, contentType) {
    return request(`/estimates/${estimateId}/photos/upload-url`, {
        method: 'POST',
        body: JSON.stringify({ filename, contentType }),
    });
}
export function recordPhoto(estimateId, photoId, s3Key, uploadedBy) {
    return request(`/estimates/${estimateId}/photos`, {
        method: 'POST',
        body: JSON.stringify({ photoId, s3Key, uploadedBy }),
    });
}
export function listPhotos(estimateId) {
    return request(`/estimates/${estimateId}/photos`);
}
export function deletePhoto(estimateId, photoId) {
    return request(`/estimates/${estimateId}/photos/${photoId}`, {
        method: 'DELETE',
    });
}
export function getSketchUploadUrl(estimateId) {
    return request(`/estimates/${estimateId}/sketch-upload-url`);
}
//# sourceMappingURL=api.js.map